const HotelsIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 18.5V4M1.5 18.5C1.5 18.5 1.5 21.5 0 21.5M1.5 18.5H22.5M22.5 18.5C22.5 18.5 22.5 21.5 24 21.5M22.5 18.5V13C22.5 12.0717 22.1313 11.1815 21.4749 10.5251C20.8185 9.86875 19.9283 9.5 19 9.5H10.5V13.5M1.5 15.5H22.5M8.5 11.4C8.5 11.4 7.5 13 6.25 13C5.78587 13 5.34075 12.8156 5.01256 12.4874C4.68437 12.1592 4.5 11.7141 4.5 11.25C4.5 10.284 5.284 9.504 6.25 9.504C7.5 9.504 8.5 11.1 8.5 11.1V11.4Z"
      stroke="black" strokeWidth="0.5"/>
  </svg>
);

export default HotelsIcon;
